import { createStore } from "vuex";
import { LIFESTAGE_LABELS, RECOMMEND_OPTION, PRICE_LIST } from "@/const";

export default createStore({
  state: {
    currentPage: "main",
    formValues: {
      persons: [
        {
          id: "p1",
          insured: true,
          isChild: false,
          gender: null,
          age: null,
          subtotalSeimei: 0,
          subtotalSeikatsu: 0,
          subtotalShushin: 0,
          subtotalTsumitate: 0,
          options: {
            seimei: {
              insured: false,
              course: null,
            },
            seikatsu: {
              insured: false,
              medical: null,
              cancer: null,
              nursing: null,
              injury: {
                type: null,
                disaster: null,
                amount: null,
              },
              compensation: null,
            },
            shushin: {
              insured: false,
              course: null,
            },
            tsumitate: {
              insured: false,
              courseA: null,
              courseB: null,
            },
          },
        },
        {
          id: "p2",
          insured: false,
          isChild: false,
          gender: null,
          age: null,
          subtotalSeimei: 0,
          subtotalSeikatsu: 0,
          subtotalShushin: 0,
          subtotalTsumitate: 0,
          options: {
            seimei: {
              insured: false,
              course: null,
            },
            seikatsu: {
              insured: false,
              medical: null,
              cancer: null,
              nursing: null,
              injury: {
                type: null,
                disaster: null,
                amount: null,
              },
              compensation: null,
            },
            shushin: {
              insured: false,
              course: null,
            },
            tsumitate: {
              insured: false,
              courseA: null,
              courseB: null,
            },
          },
        },
        {
          id: "p3",
          insured: false,
          isChild: true,
          gender: null,
          age: null,
          subtotalSeimei: 0,
          subtotalSeikatsu: 0,
          subtotalShushin: 0,
          subtotalTsumitate: 0,
          options: {
            seimei: {
              insured: false,
              course: null,
            },
            seikatsu: {
              insured: false,
              medical: null,
              cancer: null,
              nursing: null,
              injury: {
                type: null,
                disaster: null,
                amount: null,
              },
              compensation: null,
            },
            shushin: {
              insured: false,
              course: null,
            },
            tsumitate: {
              insured: false,
              courseA: null,
              courseB: null,
            },
          },
        },
        {
          id: "p4",
          insured: false,
          isChild: true,
          gender: null,
          age: null,
          subtotalSeimei: 0,
          subtotalSeikatsu: 0,
          subtotalShushin: 0,
          subtotalTsumitate: 0,
          options: {
            seimei: {
              insured: false,
              course: null,
            },
            seikatsu: {
              insured: false,
              medical: null,
              cancer: null,
              nursing: null,
              injury: {
                type: null,
                disaster: null,
                amount: null,
              },
              compensation: null,
            },
            shushin: {
              insured: false,
              course: null,
            },
            tsumitate: {
              insured: false,
              courseA: null,
              courseB: null,
            },
          },
        },
      ],
      lifestage: null,
      email: "",
    },
  },
  getters: {
    nullCheck() {
      return (v, str) => {
        if (v == null || v == "") {
          let debug = false;
          if (debug) {
            console.warn("null detected! in " + str + ":" + typeof v);
          }
        }
      };
    },
    getPerson(state, getters) {
      return (pid) => {
        getters.nullCheck(pid, "159");
        return state.formValues.persons.find((p) => p.id === pid);
      };
    },
    getLifestage(state) {
      return state.formValues.lifestage;
    },
    isInsuredPerson(state, getters) {
      return (pid) => {
        getters.nullCheck(pid, "168");
        return getters.getPerson(pid).insured;
      };
    },
    isInsuredProduct(state, getters) {
      return (pid, productId) => {
        getters.nullCheck(pid, "0001");
        getters.nullCheck(productId, "0002");
        return getters.getPerson(pid).options[productId].insured;
      };
    },
    isSelectedCondition(state, getters) {
      return (pid, productId, conditionId) => {
        getters.nullCheck(pid, "0003");
        getters.nullCheck(productId, "0004");
        getters.nullCheck(conditionId, "0004");
        return !!getters.getPerson(pid).options[productId][conditionId];
      };
    },
    getPrice(state, getters) {
      return (condition, gender, age, course, pid) => {
        getters.nullCheck(condition, "174");
        getters.nullCheck(gender, "175");
        getters.nullCheck(age, "176");
        getters.nullCheck(
          course,
          condition + ":" + gender + ":" + age + ":" + course + ":177"
        );
        // console.log(condition + ":" + gender + ":" + age + ":" + course);
        const gen =
          condition === "seimei-course" && (pid === "p3" || pid === "p4")
            ? "PRICE_C"
            : gender == 1
            ? "PRICE_M"
            : "PRICE_F";
        // console.log(gen);
        // console.log(PRICE_LIST.find((con) => con.ID === condition)[gen]);
        if (
          PRICE_LIST.find((con) => con.ID === condition) &&
          PRICE_LIST.find((con) => con.ID === condition)[gen].find(
            (pri) => pri.AGE == age
          )
        ) {
          return (
            PRICE_LIST.find((con) => con.ID === condition)[gen].find(
              (pri) => pri.AGE == age
            )[course] || 0
          );
        } else {
          return 0;
        }
      };
    },
    getOptionPrice(state, getters) {
      return (condition, gender, age, values) => {
        getters.nullCheck(condition, "194");
        getters.nullCheck(gender, "195");
        getters.nullCheck(age, "196");
        getters.nullCheck(
          values,
          condition + ":" + gender + ":" + age + ":" + values + ":197"
        );
        // console.log(values);
        // console.log(condition+":"+gender+":"+age+":"+course);
        const gen = gender == 1 ? "PRICE_M" : "PRICE_F";
        // console.log(PRICE_LIST.find((con) => con.ID === condition)[gen]);
        if (
          PRICE_LIST.find((con) => con.ID === condition) &&
          PRICE_LIST.find((con) => con.ID === condition)[gen].find(
            (pri) => pri.AGE == age
          )
        ) {
          return (
            PRICE_LIST.find((con) => con.ID === condition)[gen].find(
              (pri) => pri.AGE == age
            )[values[0]][values[1]][values[2]] || 0
          );
        } else {
          return 0;
        }
      };
    },
    getSubtotal(state, getters) {
      return (product, person) => {
        switch (product) {
          case "seimei":
            return getters.getPerson(person).subtotalSeimei;
          case "seikatsu":
            return getters.getPerson(person).subtotalSeikatsu;
          case "shushin":
            return getters.getPerson(person).subtotalShushin;
          case "tsumitate":
            return getters.getPerson(person).subtotalTsumitate;
          default:
            return 0;
        }
      };
    },
    getEmail(state) {
      return state.formValues.email;
    },
    getValueFromLabel() {
      return (arr, label) => {
        // console.log(arr);
        return (label && arr.find((obj) => obj.LABEL === label).VALUE) || 0;
      };
    },
    getFormValues(state) {
      return state.formValues;
    },
    priceFormat() {
      return (num) => {
        return new Intl.NumberFormat().format(num);
      };
    },
  },
  mutations: {
    changePage(state, payload) {
      state.currentPage = payload.next;
    },
    updateInsured(state, payload) {
      this.getters.getPerson(payload.personId).insured = payload.value;
    },
    updateGender(state, payload) {
      this.getters.getPerson(payload.personId).gender = payload.value;
    },
    updateAge(state, payload) {
      this.getters.getPerson(payload.personId).age = payload.value;
    },
    updateLifestage(state, payload) {
      state.formValues.lifestage = payload.value;
    },
    updateOption(state, payload) {
      this.getters.getPerson(payload.personId).options[
        payload.product
      ].insured = payload.value;
    },
    updateCondition(state, payload) {
      this.getters.getPerson(payload.personId).options[payload.product][
        payload.conditionId
      ] = payload.value;
    },
    updateConditionOption(state, payload) {
      this.getters.getPerson(payload.personId).options[payload.product][
        payload.conditionId
      ][payload.optionId] = payload.value;
    },
    setRecommend(state, payload) {
      this.getters.getPerson("p1").options = RECOMMEND_OPTION.find(
        (o) =>
          o.LIFESTAGE ===
          LIFESTAGE_LABELS.find((val) => val.LABEL === payload.value).VALUE
      ).OPTIONS;
    },
    updateEmail(state, payload) {
      state.formValues.email = payload.value;
    },
    updateTotal(state, payload) {
      // console.log(payload);
      this.getters.getPerson(payload.personId).subtotalSeimei =
        payload.subtotalSeimei;
      this.getters.getPerson(payload.personId).subtotalSeikatsu =
        payload.subtotalSeikatsu;
      this.getters.getPerson(payload.personId).subtotalShushin =
        payload.subtotalShushin;
      this.getters.getPerson(payload.personId).subtotalTsumitate =
        payload.subtotalTsumitate;
    },
    // updateSubtotal(state, payload) {
    //   this.getters.getPerson(payload.personId).options[
    //     payload.product
    //   ].subtotal = payload.sum;
    // },
  },
  actions: {},
  modules: {},
});
